import api from "../api";

const URL = "/api/log-entidade";

export const buscarLog = async (entidadeId, nomeEntidade, page, pageLimit) => {
  return await api.get(
    `${URL}/buscar?entidadeId=${entidadeId}&nomeEntidade=${nomeEntidade}&page=${page}&size=${pageLimit}`
  );
};
